import { Component, EventEmitter, OnInit, Input, Output } from "@angular/core";
import { SpinnerService } from "shared-components";
import { EtiquetadoService } from "../../../services/etiquetado.service";

@Component({
    selector: 'app-etq-rtq',
    templateUrl: './reetiquetadores.component.html'
})
export class ReetiquetadoresEtqComponent implements OnInit {

    public new = false;
    public reetiquetadorEditable;
    public reetiquetadoresList;
    private _filters;

    @Input() etiquetadorId;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() pushMessage = new EventEmitter<string>();

    constructor(
        private readonly _spinnerService: SpinnerService,
        private readonly _etiquetadoService: EtiquetadoService
    ) { }

    ngOnInit() {
        this._filters = {
            etiquetadorId: this.etiquetadorId
        };
        this.getRtqEtiquetador();
    }

    public getRtqEtiquetador() {
        this._spinnerService.showSpinner();
        this._etiquetadoService.getReetiquetadores(this._filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.reetiquetadoresList = resp.lista;
        });
    }

    public editableChanged(almacen) {
        this.reetiquetadoresList = almacen;
        this.new = false;
    }

    public toRefresh(value) {
        this.getRtqEtiquetador();
        this.new = false;
        this.refresh.emit(true);
    }
}
